import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getItemSegments = createAsyncThunk(
  "itemSegment/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${API_URL.ITEM_SEGMENT.SLUG}?${queryString}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Lookup variant — hits the permission-free /lookup endpoint. Used by dropdowns
// on screens of other modules; the management list keeps using getItemSegments.
export const getItemSegmentsLookup = createAsyncThunk(
  "itemSegment/getLookup",
  async (payload, { rejectWithValue }) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== "",
        ),
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${API_URL.ITEM_SEGMENT.LOOKUP}?${queryString}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createItemSegment = createAsyncThunk(
  "itemSegment/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.ITEM_SEGMENT.SLUG}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const editItemSegment = createAsyncThunk(
  "itemSegment/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.ITEM_SEGMENT.SLUG}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const deleteItemSegment = createAsyncThunk(
  "itemSegment/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(
        `${API_URL.ITEM_SEGMENT.SLUG}/${id}`,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

const itemSegmentSlice = createSlice({
  name: "itemSegment",
  initialState: {
    item_segment_list: [],
    current_values: null,
    active_payload: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getItemSegments.fulfilled, (state, action) => {
      state.item_segment_list = action.payload.data.list;
    });
    builder.addCase(getItemSegmentsLookup.fulfilled, (state, action) => {
      state.item_segment_list = action.payload.data.list;
    });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  itemSegmentSlice.actions;
export default itemSegmentSlice.reducer;
